import {ReactElement} from "react";
import {ExpandMore} from "@material-ui/icons";
import VZThinkingStatusIcon from "./VZThinkingStatusIcon";
import css from "../styles/vz-thinking.module.scss";
import {VZThinkingStepState} from "../useVZThinkingRunner";
import {IconButton} from "@zendeskgarden/react-buttons";


export interface VZThinkingHeaderProps {
    steps: VZThinkingStepState[];
    completedTitle?: string;
    isExpanded: boolean;
    onToggle: () => void;
}

export default function VZThinkingHeader(props: VZThinkingHeaderProps): ReactElement {
    const activeStep = props.steps.find(step => step.status === "active");

    let totalCount = 0;
    let completedCount = 0;
    for (const step of props.steps) {
        const stepCount = Math.max(step.substepCount, 1);
        totalCount += stepCount;

        if (step.status === "complete") {
            completedCount += stepCount;
        } else if (step.status === "active") {
            completedCount += step.substepIndex ?? 0;
        }
    }

    const progressPercent = totalCount > 0 ? completedCount / totalCount * 100 : 100;
    const title = activeStep ? activeStep.title : props.completedTitle ?? "Finished";

    return (
        <div className={css.header}>
            <div className={css.headerToggle}>
                <VZThinkingStatusIcon status={activeStep ? "active" : "complete"} />
                <span key={title} className={`${css.headerTitle} ${!activeStep ? css.isComplete : ""}`}>{title}</span>
                <span className={css.headerCount}>{completedCount} of {totalCount}</span>

                <IconButton
                    size="small"
                    className={`${css.expandIcon} ${props.isExpanded ? css.expandIconExpanded : ""}`}
                    onClick={props.onToggle}
                    aria-label="expand or collapse step list"
                >
                    <ExpandMore />
                </IconButton>
            </div>

            <div className={css.progressTrack}>
                <div
                    className={css.progressFill}
                    style={{width: `${progressPercent}%`}}
                />
            </div>
        </div>
    );
}
